import { useTranslation } from '@bcba/react-hooks';
import { CropPledgeInformationProvider } from './context/CropPledgeInformationContext';
import { Badge, Center, Flex, Spinner } from '@agrotoken-tech/ui';
import { FormSection } from '../../shared';
import { PLEDGE_SECTION_STATUSES_ICON } from '@bcba/frontend-utils';
import { useCropPledgeInformationContext } from './context/CropPledgeInformationContext';
import PledgeInformationForm from './components/PledgeInformationForm/PledgeInformationForm';

const PledgeInformationSection = () => {
  const { t } = useTranslation();
  const {
    data,
    isLoading,
    cropPledgeSectionsStatusBadgeColors,
    pledgeInformationStatus,
  } = useCropPledgeInformationContext();

  if (isLoading || !data) {
    return (
      <Center mt="8">
        <Spinner />
      </Center>
    );
  }

  return (
    <Flex flexDir={'column'} pb={8}>
      <FormSection
        title={t('cropPledgeDetail.asideNav.cropPledgeData')}
        badge={
          <Badge
            icon={PLEDGE_SECTION_STATUSES_ICON[pledgeInformationStatus]}
            colorScheme={
              cropPledgeSectionsStatusBadgeColors[pledgeInformationStatus]
            }
            mr="2"
            iconPosition="leading"
          >
            {t(`cropPledge.section.status.${pledgeInformationStatus}`)}
          </Badge>
        }
      >
        <PledgeInformationForm />
      </FormSection>
    </Flex>
  );
};

const PledgeInformation = () => {
  return (
    <CropPledgeInformationProvider>
      <PledgeInformationSection />
    </CropPledgeInformationProvider>
  );
};

export default PledgeInformation;
